
export enum BrowserType {
    FIREFOX = 'FIREFOX',
    EDGE = 'EDGE',
    IE = 'IE',
    OPERA = 'OPERA',
    VIVALDI = 'VIVALDI',
    CHROME = 'CHROME',
    SAFARI = 'SAFARI',
    UNKNOWN = 'UNKNOWN',
    UNDEFINED = 'UNDEFINED'

}

const checkCurrentBrowser = (): BrowserType => {
    if (isFirefox()) {
        return BrowserType.FIREFOX;
    } else if (isEdge()) {
        return BrowserType.EDGE;
    } else if (isIE()) {
        return BrowserType.IE;
    } else if (isOpera()) {
        return BrowserType.OPERA;
    } else if (isVivaldi()) {
        return BrowserType.VIVALDI;
    } else if (isChrome()) {
        return BrowserType.CHROME;
    } else if (isSafari()) {
        return BrowserType.SAFARI;
    } else {
        return BrowserType.UNKNOWN;
    }
}

function agentHas(keyword: string) {
    return navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
}

function isIE() {
    return document.hasOwnProperty('documentMode');
}

function isSafari() {
    return (window.hasOwnProperty('ApplePaySetupFeature') || window.hasOwnProperty('safari')) && agentHas("Safari") && !agentHas("Chrome") && !agentHas("CriOS");
}

function isChrome() {
    return agentHas("CriOS") || agentHas("Chrome") || window.hasOwnProperty('chrome');
}

function isFirefox() {
    return agentHas("Firefox") || agentHas("FxiOS") || agentHas("Focus");
}

function isEdge() {
    return agentHas("Edg");
}

function isOpera() {
    return agentHas("OPR");
}

function isVivaldi() {
    return agentHas("Vivaldi");
}

export {
    checkCurrentBrowser
}
